// extracted by mini-css-extract-plugin
export default {"contenedorImagenPerfil":"bagageUser_contenedorImagenPerfil__j7Noc","contentAvatarUser":"bagageUser_contentAvatarUser__kvxEC","avatarUser":"bagageUser_avatarUser__6s+fv"};